module.exports = __webpack_public_path__ + "img/innsjodatabase.9017b197.jpg";